import React, { useEffect, useState } from "react";
import { DollarSign, CheckCircle2, XCircle } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function MonetizationApprovals({ endpoint = "/monetization/pending", title = "Premium pack approvals" }) {
  const [reqs, setReqs] = useState([]);
  const load = () => api.get(endpoint).then((r) => setReqs(r.data || [])).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [endpoint]);
  const decide = async (gameId, action) => {
    try {
      await api.post(`/monetization/${gameId}/${action}`);
      toast.success(action === "approve" ? "Premium pack approved 💰" : "Premium pack rejected");
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  if (reqs.length === 0) return null;
  return (
    <div className="rounded-2xl border border-amber-500/30 bg-amber-500/5 p-5 mb-6" data-testid="monetization-approvals">
      <h2 className="font-bold mb-3 flex items-center gap-2"><DollarSign className="w-4 h-4 text-amber-500" /> {title} ({reqs.length})</h2>
      <div className="space-y-2">
        {reqs.map((r) => (
          <div key={r.game_id} className="flex items-center gap-3 rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-3" data-testid={`mon-req-${r.game_id}`}>
            <span className="text-2xl shrink-0">{r.cover_emoji || "🎮"}</span>
            <div className="flex-1 min-w-0">
              <div className="font-semibold truncate">{r.pack_title} <span className="text-[hsl(var(--muted-foreground))]">· ${r.price}</span></div>
              <div className="text-xs text-[hsl(var(--muted-foreground))] truncate">{r.title} · by {r.owner_name}</div>
            </div>
            <Button size="sm" className="rounded-full bg-emerald-500 hover:bg-emerald-600 shrink-0" onClick={() => decide(r.game_id, "approve")} data-testid={`mon-approve-${r.game_id}`}><CheckCircle2 className="w-4 h-4" /> Approve</Button>
            <Button size="sm" variant="outline" className="shrink-0" onClick={() => decide(r.game_id, "reject")} data-testid={`mon-reject-${r.game_id}`}><XCircle className="w-4 h-4" /> Reject</Button>
          </div>
        ))}
      </div>
    </div>
  );
}
